<div id="todo" class="page-layout carded left-sidebar">

  <!-- TOP BACKGROUND -->
  <div class="top-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- CONTENT HEADER -->
    <div class="header  p-24" fxLayout="row" fxLayoutAlign="start center">
      <h2 class="m-0">{{'CONSULTATABLA.TITULO' | translate}}</h2>
    </div>
    <!-- / CONTENT HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card" [ngClass]="">

      <!-- CONTENT TOOLBAR -->
      <div class="toolbar primary px-24 py-8">
        <span>{{'CONSULTATABLA.HEADER' | translate}}</span>
      </div>
      <!-- / CONTENT TOOLBAR -->

      <!-- CONTENT -->
      <div  fxLayout="column" fxLayoutAlign="start stretch" class=" content p-20" fusePerfectScrollbar>
        <div class="" fxLayout="row" fxLayoutAlign="space-between stretch" fxLayout.sm="column" fxLayout.xs="column">
          <div  fxFlex="50" >
            <mat-form-field   appearance="outline" fxFlex>
              <mat-label>{{'CONSULTATABLA.BUSCAR' | translate}}</mat-label>
              <input matInput [(ngModel)]='busqueda' (keyup)="getListaEmpresas(1)" placeholder="{{'CONSULTATABLA.BUSCAR_PLACEH' | translate}}">
            </mat-form-field>
          </div>
          <div  fxLayout.sm="row" fxLayoutAlign="space-between stretch" fxLayout.xs="row">
            <div fxFlex="25" fxLayout="row" fxLayoutAlign="space-between center" style="margin-left:20px">
              <mat-checkbox  [(ngModel)]= "checkedCGO" (change)="filterPlatform($event,1)" class="checkBox" >CGO</mat-checkbox>
              <mat-checkbox [(ngModel)]= "checkedEXPRESS" (change)="filterPlatform($event,2)" class="checkBox" >Express</mat-checkbox>
              <mat-checkbox [(ngModel)]= "checkedSWFIT" (change)="filterPlatform($event,3)" class="checkBox"  >Swift</mat-checkbox>
            </div>
            <div fxFlex="25" fxLayout="row" fxLayoutAlign="end center">
              <h3><b>{{contadorInicio}} - {{contadorFin}}</b> {{'CONSULTATABLA.PAGINATOR_1' | translate}} <b>{{totalEmpresas}}</b> {{'CONSULTATABLA.PAGINATOR_2' | translate}}</h3>
              <button mat-icon-button (click)="getListaEmpresas(prevPag)">
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
              <button mat-icon-button (click)="getListaEmpresas(nextPag)">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
            </div>
          </div>

        </div>

        <ng-container *ngIf="cargando; else tablaEmp">
          <div fxLayout="column" fxLayoutAlign="space-between center">
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h1>{{'CONSULTATABLA.GETLISTAEMP' | translate}}</h1>
          </div>
        </ng-container>

          <ng-template #tablaEmp >
              <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" [@animate]="{value:'*',params:{delay:'500ms', y:'25px'}}" >
                <!-- ID Column -->
                <ng-container matColumnDef="empresa">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="tituloEmpresa" [id]="tablaEmeep" > {{'CONSULTATABLA.EMPRESA' | translate}} </th>
                  <td mat-cell *matCellDef="let row" class="p-10">
                    {{row.datosEmpresa.nombreEmpresa}}<br>
                    <ng-container *ngIf="institutoId == 0 && row.datosEmpresa.institutoEmpresa!= 14">
                      <code>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO' | translate}} {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+row.datosEmpresa.institutoEmpresa | translate}}</code>
                      <br>
                      <code class="tipoEmpre" *ngIf="row.datosEmpresa.institutoEmpresa != 19">{{'CONSULTATABLA.TIPO_EMPRESA.'+row.datosEmpresa.platform | translate}} </code>
                    </ng-container>
                    <ng-container *ngIf="institutoId == 0 && row.datosEmpresa.institutoEmpresa== 14">
                      <code> {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+row.datosEmpresa.institutoEmpresa | translate}}</code>
                      <br>
                      <code class="tipoEmpre">{{'CONSULTATABLA.TIPO_EMPRESA.'+row.datosEmpresa.platform | translate}} </code>
                    </ng-container>
                  </td>
                </ng-container>
                <ng-container matColumnDef="creatDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="tituloEmpresa"> {{'CONSULTATABLA.CREAT_DATE_EMP' | translate}} </th>
                  <td mat-cell *matCellDef="let row" class="p-10">
                    {{row.createdAt |date:"d MMM y H:mm": "+0000":idiomaActual}}<br>
                  </td>
                </ng-container>
                <!-- <ng-container matColumnDef="typeRegis">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="tituloEmpresa"> {{'CONSULTATABLA.TYP_REGISTR_EMP' | translate}} </th>
                  <td mat-cell *matCellDef="let row" class="p-10"></td>
                </ng-container> -->
                <ng-container matColumnDef="Autor">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="tituloEmpresa"> {{'CONSULTATABLA.AUTOR_EMP' | translate}} </th>
                  <td mat-cell *matCellDef="let row" class="p-10">
                    <ng-container  *ngIf="row.datosEmpresa.platform==1 || row.datosEmpresa.platform==2">
                    <ng-container  *ngIf="row.userResponsable!=undefined">
                      {{row.userResponsable.user}}
                    </ng-container>
                    <ng-container  *ngIf="row.userResponsable==undefined">
                    </ng-container>
                    </ng-container>

                    <ng-container  *ngIf="row.datosEmpresa.platform==3">
                    <ng-container  *ngIf="row.swift_agent!=undefined">
                      {{row.swift_agent.email}}
                    </ng-container>
                    <ng-container  *ngIf="row.swift_agent==undefined">
                      <ng-container  *ngIf="row.swift_user!=undefined">
                        {{row.swift_user.email}}
                      </ng-container>
                      <ng-container  *ngIf="row.swift_user==undefined"></ng-container>

                    </ng-container>
                    </ng-container>


                    </td>
                </ng-container>
                <!-- Progress Column -->
                <ng-container matColumnDef="accion">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'CONSULTATABLA.ACCION' | translate}} </th>
                  <td mat-cell *matCellDef="let row">

<nav >
		<ul class="mcd-menu">
			<li>
				<a><i><mat-icon>arrow_left_alt</mat-icon></i><strong>{{'CONSULTATABLA.ACCION' | translate}}</strong></a>
			<ul>
					<li (click)="autologin(row._id);"><a class="login"><i><mat-icon>keyboard_tab</mat-icon></i>{{'CONSULTATABLA.LOGIN' | translate}}</a></li>
					<li (click)="getEnterpriseDetail(row._id);"><a class="login"><i><mat-icon>list_alt</mat-icon></i>{{'CONSULTATABLA.DETALLE' | translate}}</a></li>
          <li (click)="showSurveyStatus(row._id,row.datosEmpresa.institutoEmpresa);" ><a class="survey"><i><mat-icon>insert_chart</mat-icon></i>{{'CONSULTATABLA.STATUS' | translate}}</a></li>
          <ng-container *ngIf="row.datosEmpresa.platform == 1" >
          <li *ngIf="row.nueva && row.datosEmpresa.institutoEmpresa == 1" (click)="infoPaquete(row._id);"><a class="login"><i><mat-icon>work</mat-icon></i>{{'CONSULTATABLA.PAQUETES' | translate}}</a></li>
          <li *ngIf="row.nueva && row.datosEmpresa.institutoEmpresa == 1" (click)="showReqTec(row._id);"><a class="login"><i><mat-icon>linear_scale</mat-icon></i>{{'CONSULTATABLA.TIMELINE' | translate}}</a></li>
          <li (click)="showManagerTI(row._id)"><a class="login"><i><mat-icon>account_circle</mat-icon></i>{{'CONSULTATABLA.MANAGER_TI' | translate}}</a></li>
          </ng-container>
          <li (click)="editCompany(row._id);"><a class="login"><i><mat-icon>edit</mat-icon></i>{{'CONSULTATABLA.EDITAR' | translate}}</a></li>
          <li (click)="borrarEmpresa(row.datosEmpresa.nombreEmpresa,row._id);"><a class="delete"><i><mat-icon>delete_forever</mat-icon></i>{{'CONSULTATABLA.ELIMINAR' | translate}}</a></li>
        </ul>
			</li>
		</ul>
	</nav>
                  </td>

                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
              </table>

          </ng-template>



      </div>
      <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

  </div>
  <!-- / CENTER -->

</div>
